const styles = theme => ({
  grid: {
    width: '100%',
    //maxWidth: 610,
    flexBasis: 'unset',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '16px',
    maxWidth: '752',
  },
})

export default styles
